import { get } from '.';
import qs from 'qs';

export const getCategories = ({ filters }) => {
  return get(`/categories?${qs.stringify(filters)}`);
};
